import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

export type CPSSOEgressAuthLoc = 'CPSSOEgressAuthorizationOIDC';

export const cpSSOAuthLocs: LocDefs<CPSSOEgressAuthLoc> = {
	CPSSOEgressAuthorizationOIDC: {
		defaultValue: 'Authorizing',
		description: 'Page title displayed while loading on the SSO egress authorization page',
		displayPath: `SSO|Egress|OIDC Authorization Loading`,
		displayType: 'Title',
		htmlAllowed: false,
		feature: HubFeature.CandidateAccessIntegrationEgressOidcEgress,
		shared: false,
		portal: 'CP',
	},
};

export const LOC_KEYS = MapLocKeys<CPSSOEgressAuthLoc>(cpSSOAuthLocs);
